export default __webpack_public_path__ + "static/media/paypal.730c3d19.jpg";